import { Directory, DocumentChildType } from './directory'
import { DirectoryWithIcon } from './directoryWithIcon'
import { Document } from './document'

export type Seed = {
    slug: string //locizeId - without slash
    parentSlug: string // slug without slash or root
    title: string
    content?: string
    icon?: string
}

export type SeedLocize = {
    text?: string
    content?: string
    icon?: string
}

export type GetSeedData = (slug: string) => SeedLocize

export class TreeSeeder {
    public static plantTree = (seeds: Seed[]): Directory<DocumentChildType> => {
        const root = this._plantTree(
            seeds.sort((s1, s2) => s1.parentSlug.localeCompare(s2.parentSlug)),

            new Directory('Partner-leksikon', '/lexicon')
        )
        root.initializeSearch()
        return root
    }

    private static _plantTree = (
        seeds: Seed[],
        root: Directory<DocumentChildType>
    ): Directory<DocumentChildType> => {
        if (seeds.length === 0) return root

        const seed = seeds[0]
        const parent = root.findChildBySlug(seed.parentSlug)
        const node = this._nodeFromSeed(seed)

        if (node !== 'ERROR') {
            if (
                parent.type === 'directory' ||
                parent.type === 'directoryWithIcon'
            )
                (parent as Directory<any>).addChild(node)
        }

        return this._plantTree(seeds.splice(1), root)
    }

    private static _nodeFromSeed = (
        seed: Seed
    ): Directory<any> | Document | DirectoryWithIcon | 'ERROR' => {
        if (!seed || !seed.title || !seed.slug || !seed.parentSlug)
            return 'ERROR'
        const { icon, content, title, slug } = seed
        if (icon) {
            return new DirectoryWithIcon(title, slug, {
                name: icon,
            })
        } else if (content) {
            return new Document(title, slug, content)
        } else {
            return new Directory(title, slug)
        }
    }
}
